
<div class="summary-container" [class.summary-container--service-order]="openedDocument?.salesDocumentTypeId === 5">
    <div id="side-switch" *ngIf="openedDocument?.salesDocumentTypeId !== 5">

        <span
            *ngIf="offerRecalculationMethod() === 'wholeOffer'"
            class="info-container"
            [title] = "getCalculationInfo()"
            (touchstart)="addCalculationInfo()"
        >
            <icc-calculation-indicator
                [animation]="synced !== 'synced'"
            ></icc-calculation-indicator>
        </span>

        <button class="tab" data-test="sale-side" [class.active]="mode == 'sale'" (click)="switchMode('sale')" *ngIf="hasAccessToSale" translate>SALES_DOCUMENT|Sprzedaż</button>
        <button class="tab" data-test="comparison-side" [class.active]="mode == 'comparison'" (click)="switchMode('comparison')" *ngIf="hasAccessToBuy && hasAccessToSale && integral && hasAccessTo.viewBuyPrices" translate>SALES_DOCUMENT|Porównanie</button>
        <button class="tab locked" data-test="comparison-side" [class.active]="mode == 'comparison'" (click)="showIntegrityWarning()" *ngIf="hasAccessToBuy && hasAccessToSale && !integral && hasAccessTo.viewBuyPrices"><icc-icon name="exclamation-triangle"></icc-icon> {{ 'SALES_DOCUMENT|Porównanie' | translate }}</button>
        <button class="tab" data-test="purchase-side" [class.active]="mode == 'purchase'" (click)="switchMode('purchase')" *ngIf="hasAccessToBuy">
            {{ 'SALES_DOCUMENT|Zakup' | translate }}<span class="order-not-placed" *ngIf="getStatus(buyDocuments[0])?.code === 'ORDER_NOT_PLACED'"> - {{ 'SALES_DOCUMENT|niezłożone u producenta' | translate }}</span>
        </button>

    </div>
    <div id="options">

        <icc-sales-document-details
            [document]="salesDocument"
            [positions]="positions"
            (sellerChange)="onSellerChange()"
            *ngIf="(mode == 'sale' || mode == 'comparison') && salesDocument"
            [priceVersion]="priceVersionObj"
            [groupingSchemaId]="groupingSchemaId"
            [sortingMode]="sortingMode"
            [hasAccessToEditCode]="hasAccessTo.editCode"
            [hasAccessToEditRequestedDeadline]="hasAccessTo.editRequestedDeadline"
        ></icc-sales-document-details>

        <ng-container  *ngIf="(mode == 'purchase' || mode == 'comparison') && buyDocuments?.length">

            <icc-sales-document-details
                [document]="activeBuyDocument"
                [salesDocument]="salesDocument"
                [documentList]="buyDocuments"
                [positions]="(mode === 'purchase' ? buyPositionsPerDocument[activeBuyDocument?.uuid] : connectedBuyPositions[activeBuyDocument?.uuid]) || []"
                (sellerChange)="onSellerChange()"
                (documentChange)="onActiveBuyDocumentChange($event)"
                [groupingSchemaId]="groupingSchemaId"
                [sortingMode]="sortingMode"
            ></icc-sales-document-details>

        </ng-container>

    </div>
    <div id="summary-table"  *ngIf="openedDocument?.salesDocumentTypeId !== 5">

        <ng-container *ngIf="canChangeSaleCurrency && salesDocument && (mode === 'comparison' || mode === 'sale') && currencies.length > 1">
            <div class="icc-card">
                <label class="icc-card__label" *ngIf="mode === 'sale'">
                    {{ 'SALES_DOCUMENT|Waluta sprzedaży:' | translate }}
                </label>
                <label class="icc-card__label" *ngIf="mode === 'comparison'">
                    {{ 'SALES_DOCUMENT|Waluta sprzedaży/porównania:' | translate }}
                </label>

                <span class="icc-card__content" >
                    <icc-select
                        size="small"
                        [ngModel]="salesDocument.priceCurrency"
                        (ngModelChange)="changeCurrency($event)"
                        [disabled]="salesDocument.isConfirmed || salesDocument.isCanceled || salesDocument.salesDocumentTypeId === 2"
                    >
                        <option *ngFor="let currency of currencies" [value]="currency.code">{{ currency.code }}</option>
                    </icc-select>
                </span>
            </div>
        </ng-container>
        <ng-container *ngxPermissionsOnly="'icadmin-price-versions-list-b2b'">
            <div class="icc-card" *ngIf="salesDocument && (mode === 'comparison' || mode === 'sale')">
                <div>
                    <label class="icc-card__label">
                        {{ 'PRICE_VERSION|Wersja cenowa:' | translate }}
                    </label>

                    <div class="icc-card__content" id="price-version-card-content">
                        <div class="price-version-name">
                            <div [ngClass]="{'invalid': (invalidVersion || invalidVersionEffectiveDate || invalidVersionExpiredDate) && !salesDocument.isCanceled && !(priceUpdatePending$ | async)}">
                                {{priceVersionObj?.name}}
                            </div>
                            <div class="right">
                                <button
                                    iccIconButton
                                    appearance="flat"
                                    (click)="openPriceVersionDialog(priceVersionObj)"
                                    *ngIf="priceVersions.length > 1 && !salesDocument.isConfirmed && !salesDocument.isConfirmedOnlySalesPositions && salesDocument.salesDocumentTypeId !== 2"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                                <button
                                    iccIconButton
                                    appearance="flat"
                                    (click)="confirmRecalculate(salesDocument)"
                                    *ngIf="invalidVersion && priceVersions.length === 1 && !salesDocument.isConfirmed && !salesDocument.isConfirmedOnlySalesPositions && salesDocument.salesDocumentTypeId !== 2"
                                >
                                    <icc-icon name="calculate"></icc-icon>
                                </button>
                            </div>
                        </div>

                        <div class="price-version-dates">
                            <span *ngIf='priceVersionObj?.effectiveDate' [class.invalid]="invalidVersionEffectiveDate">
                                {{ 'INTERFACE|Od:' | translate }} {{ priceVersionObj?.effectiveDate | date : 'short' }}
                            </span>
                            <span *ngIf='priceVersionObj?.expiredDate' [class.invalid]="invalidVersionExpiredDate">
                                {{ 'INTERFACE|Do:' | translate }} {{ priceVersionObj?.expiredDate | date : 'short' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="icc-card" *ngIf="hasAccessTo.buyCurrency && (salesCurrenciesFromBuy && !canChangeSaleCurrency || mode === 'comparison' || mode === 'purchase' && hasAccessTo.viewBuyPrices) && buyCurrencies.length > 1">
            <label class="icc-card__label" *ngIf="!salesCurrenciesFromBuy || canChangeSaleCurrency">
                {{ 'SALES_DOCUMENT|Waluta zakupu:' | translate }}
            </label>
            <label class="icc-card__label" *ngIf="salesCurrenciesFromBuy && !canChangeSaleCurrency && mode === 'sale'">
                {{ 'SALES_DOCUMENT|Waluta:' | translate }}
            </label>
            <label class="icc-card__label" *ngIf="salesCurrenciesFromBuy && !canChangeSaleCurrency && (mode === 'comparison' || mode === 'purchase')">
                {{ 'SALES_DOCUMENT|Waluta zakupu/sprzedaży:' | translate }}
            </label>
            <span class="icc-card__content">
                <icc-select
                    size="small"
                    [ngModel]="buyDocuments[0]?.priceCurrency"
                    (ngModelChange)="changeBuyCurrency($event)"
                >
                    <option *ngFor="let currency of buyCurrencies" [value]="currency.code">
                        {{ currency.code }}
                    </option>
                </icc-select>
            </span>
        </div>


        <table *ngIf="mode === 'sale' && summary.sales || mode === 'purchase' && summary.buy && hasAccessTo.viewBuyPrices || mode === 'comparison' && summary.buySales">
            <thead>
                <tr>
                    <th></th>
                    <th *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ 'SALES_DOCUMENT|Sprzedaż' | translate }}</th>
                    <th *ngIf="isComparable">{{ 'SALES_DOCUMENT|Sprzedaż (znane ceny zakupu)' | translate }}</th>
                    <th *ngIf="isComparable">
                        <ng-container *ngIf="summary.buy?.currency != summary.buySales?.currency">{{ 'SALES_DOCUMENT|Zakup - przeliczone na {salesCurrency}' | translate: { salesCurrency: summary.buySales?.currency} }} <i>({{ summary.buy?.currency }})</i></ng-container>
                        <ng-container *ngIf="summary.buy?.currency == summary.buySales?.currency">{{ 'SALES_DOCUMENT|Zakup' | translate }}</ng-container>
                    </th>
                    <th *ngIf="mode === 'purchase'">{{ 'SALES_DOCUMENT|Zakup' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr class="total">
                    <td *ngIf="isGrossLabel">{{ 'SALES_DOCUMENT|Wartość pozycji brutto:' | translate }}</td>
                    <td *ngIf="!isGrossLabel">{{ 'SALES_DOCUMENT|Wartość pozycji netto:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ summary.sales.positions | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">{{ summary.buySales.positions | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        {{ summary.buy.positions | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.positions | currency: summary.buy.currency }})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">
                        {{ summary.buy.positions | currency: summary.buy.currency }}
                    </td>
                </tr>
                <ng-container *ngIf="summary.groups.length > 1">
                    <tr *ngFor="let group of summary.groups">
                        <td *ngIf="isGrossLabel" class="intent">{{ 'SALES_DOCUMENT|w tym {groupName} brutto' | translate: {groupName: (group.name | translate)} }}</td>
                        <td *ngIf="!isGrossLabel" class="intent">{{ 'SALES_DOCUMENT|w tym {groupName} netto' | translate: {groupName: (group.name | translate)} }}</td>
                        <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ group.sales?.value | currency: summary.sales.currency }}</td>
                        <td *ngIf="isComparable">{{ group.buySales?.value | currency: summary.buySales.currency }}</td>
                        <td *ngIf="isComparable">
                            {{ group.buy?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                            <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                                ({{ group.buy?.value | currency: summary.buy.currency }})
                            </span>
                        </td>
                        <td *ngIf="mode === 'purchase'">
                            {{ group.buy?.value | currency: summary.buy.currency }}
                        </td>
                    </tr>
                </ng-container>
                <ng-container *ngFor="let group of summary.groupsPositions">
                    <tr>
                        <td *ngIf="isGrossLabel">{{ 'SALES_DOCUMENT|{groupName} brutto' | translate: {groupName: (group.name | translate)} }}</td>
                        <td *ngIf="!isGrossLabel">{{ 'SALES_DOCUMENT|{groupName} netto' | translate: {groupName: (group.name | translate)} }}</td>
                        <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ group.sales?.total | currency: summary.sales.currency }}</td>
                        <td *ngIf="isComparable">{{ group.buySales?.total | currency: summary.buySales.currency }}</td>
                        <td *ngIf="isComparable">
                            {{ group.buy?.total  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                            <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                                ({{ group.buy?.total  | currency: summary.buy.currency }})
                            </span>
                        </td>
                        <td *ngIf="mode === 'purchase'">
                            {{ group.buy?.total  | currency: summary.buy.currency }}
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td>{{ 'SALES_DOCUMENT|RAZEM:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ summary.sales.totalBeforeDiscountsAndPromotions | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">{{ summary.buySales.totalBeforeDiscountsAndPromotions | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        {{ summary.buy.totalBeforeDiscountsAndPromotions | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalBeforeDiscountsAndPromotions | currency: summary.buy.currency }})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">
                        {{ summary.buy.totalBeforeDiscountsAndPromotions | currency: summary.buy.currency }}
                    </td>
                </tr>
                <tr *ngIf="summary.sales?.promotion?.value || summary.buySales?.promotion?.value || summary.buy?.promotion?.value">
                    <td>{{ 'SALES_DOCUMENT|Wartość promocji:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">({{ summary.sales.promotion.promotion / 100 | percent : '1.0-2' }}) {{ summary.sales.promotion.value | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">({{ summary.buySales.promotion.promotion / 100 | percent : '1.0-2' }}) {{ summary.buySales.promotion.value | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        ({{ summary.buy.promotion?.promotion / 100 | percent : '1.0-2' }}) {{ summary.buy.promotion?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.promotion?.value | currency: summary.buy.currency }})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">({{ summary.buy.promotion?.promotion / 100 | percent : '1.0-2' }}) {{ summary.buy.promotion.value | currency: summary.buy.currency }}</td>
                </tr>
                <tr *ngIf="summary.sales?.promotion?.value || summary.buySales?.promotion?.value || summary.buy?.promotion?.value">
                    <td>{{ 'SALES_DOCUMENT|RAZEM PO PROMOCJI:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ summary.sales.totalAfterPromotions | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">{{ summary.buySales.totalAfterPromotions | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        {{ summary.buy.totalAfterPromotions | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalAfterPromotions | currency: summary.buy.currency }})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">
                        {{ summary.buy.totalAfterPromotions | currency: summary.buy.currency }}
                    </td>
                </tr>
                <tr>
                    <td>{{ 'SALES_DOCUMENT|Rabat:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ summary.sales.totalDiscount | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">{{ summary.buySales.totalDiscount | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        {{ summary.buy.totalDiscount | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalDiscount | currency: summary.buy.currency }})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">
                        {{ summary.buy.totalDiscount | currency: summary.buy.currency }}
                    </td>
                </tr>
                <tr>
                    <td class="intent">{{ 'SALES_DOCUMENT|w tym rabat do pozycji:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">({{ summary.sales.discount.discount / 100 | percent : '1.0-2' }}) {{ summary.sales.discount.value | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">({{ summary.buySales.discount.discount / 100 | percent : '1.0-2' }}) {{ summary.buySales.discount.value | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        ({{ summary.buy.discount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buy.discount?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.discount?.value | currency: summary.buy.currency }})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">({{ summary.buy.discount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buy.discount.value | currency: summary.buy.currency }}</td>
                </tr>
                <tr>
                    <td class="intent">{{ 'SALES_DOCUMENT|w tym rabat dodatkowy:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">({{ summary.sales.additionalDiscount.discount / 100 | percent : '1.0-2' }}) {{ summary.sales.additionalDiscount.value | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">({{ summary.buySales.additionalDiscount.discount / 100 | percent : '1.0-2' }}) {{ summary.buySales.additionalDiscount.value | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        ({{ summary.buy.additionalDiscount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buy.additionalDiscount?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.additionalDiscount?.value | currency: summary.buy.currency }})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">({{ summary.buy.additionalDiscount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buy.additionalDiscount.value | currency: summary.buy.currency }}</td>
                </tr>
                <tr *ngIf="!isGrossLabel">
                    <td>{{ 'SALES_DOCUMENT|RAZEM NETTO:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ summary.sales.totalAfterDiscounts | currency: summary.sales.currency }}</td>
                    <td *ngIf="isComparable">{{ summary.buySales.totalAfterDiscounts | currency: summary.buySales.currency }}</td>
                    <td *ngIf="isComparable">
                        {{ summary.buy.totalAfterDiscounts | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalAfterDiscounts | currency: summary.buy.currency}})
                        </span>
                    </td>
                    <td *ngIf="mode === 'purchase'">
                        {{ summary.buy.totalAfterDiscounts | currency: summary.buy.currency}}
                    </td>
                </tr>
                <ng-container *ngFor="let tax of summary.taxes">
                    <tr *ngIf="(mode === 'comparison' || mode === 'sale') && tax.sales || (isComparable || mode === 'purchase') && tax.buy">
                        <td>{{ 'SALES_DOCUMENT|VAT {rate}' | translate: {rate: (tax.taxRate / 100 | percent)} }}</td>
                        <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ tax.sales?.tax | currency: summary.sales.currency : '—' }}</td>
                        <td *ngIf="isComparable">{{ tax.buySales?.tax | currency: summary.buySales.currency : '—' }}</td>
                        <td *ngIf="isComparable">
                            {{ tax.buy?.tax  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency : '—' }}
                            <span class="buy-currency-price" *ngIf="tax.buy?.tax != null && summary.buy?.currency != summary.buySales?.currency">
                                ({{ tax.buy?.tax | currency: summary.buy.currency }})
                            </span>
                        </td>
                        <td *ngIf="mode === 'purchase'">
                            {{ tax.buy?.tax | currency: summary.buy.currency : '—' }}
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td>{{ 'SALES_DOCUMENT|RAZEM BRUTTO:' | translate }}</td>
                    <td *ngIf="(mode === 'sale' || mode === 'comparison') && !activeBuyDocument">{{ summary.sales.totalGrossAfterDiscounts | currency: summary.sales.currency }}<span *ngIf="summary.sales.hasNonValuatedPositions" class="non-valuated">* {{ 'SALES_DOCUMENT|Do wyceny' | translate }}</span></td>
                    <td *ngIf="isComparable">{{ summary.buySales.totalGrossAfterDiscounts | currency: summary.buySales.currency }}<span *ngIf="summary.buySales.hasNonValuatedPositions" class="non-valuated">* {{ 'SALES_DOCUMENT|Do wyceny' | translate }}</span></td>
                    <td *ngIf="isComparable">
                        {{ summary.buy.totalGrossAfterDiscounts | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalGrossAfterDiscounts | currency: summary.buy.currency }})</span><span *ngIf="summary.buy.hasNonValuatedPositions" class="non-valuated">* {{ 'SALES_DOCUMENT|Do wyceny' | translate }}</span>
                    </td>
                    <td *ngIf="mode === 'purchase'">
                        {{ summary.buy.totalGrossAfterDiscounts | currency: summary.buy.currency }}<span *ngIf="summary.buy.hasNonValuatedPositions" class="non-valuated">* {{ 'SALES_DOCUMENT|Do wyceny' | translate }}</span>
                    </td>
                </tr>

                <tr *ngIf="isComparable && !activeBuyDocument">
                    <td></td>
                    <td></td>
                    <td *ngIf="!isGrossLabel">{{ 'SALES_DOCUMENT|Wynik netto:' | translate }}</td>
                    <td *ngIf="isGrossLabel">{{ 'SALES_DOCUMENT|Wynik brutto:' | translate }}</td>
                    <td>{{ summary.result.value | currency: currency }}</td>
                </tr>
                <tr *ngIf="isComparable && !activeBuyDocument">
                    <td></td>
                    <td></td>
                    <td>{{ 'SALES_DOCUMENT|Marża:' | translate }}</td>
                    <td>{{ summary.result.margin | percent }}</td>
                </tr>
                <tr *ngIf="isComparable && !activeBuyDocument">
                    <td></td>
                    <td></td>
                    <td>{{ 'SALES_DOCUMENT|Narzut:' | translate }}</td>
                    <td>{{ summary.result.overhead | percent }}</td>
                </tr>
            </tbody>
        </table>
        <table *ngIf="!isComparable && mode === 'comparison'">
            <thead>
                <tr>
                    <th></th>
                    <th>{{ 'SALES_DOCUMENT|Sprzedaż (znane ceny zakupu)' | translate }}</th>
                    <th>
                        <ng-container *ngIf="summary.buy?.currency != summary.buySales?.currency">{{ 'SALES_DOCUMENT|Zakup - przeliczone na {salesCurrency}' | translate: { salesCurrency: summary.buySales?.currency} }} <i>({{ summary.buy?.currency }})</i></ng-container>
                        <ng-container *ngIf="summary.buy?.currency == summary.buySales?.currency">{{ 'SALES_DOCUMENT|Zakup' | translate }}</ng-container>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="total">
                    <td>{{ 'SALES_DOCUMENT|Wartość pozycji netto:' | translate }}</td>
                    <td>{{ summary.buySales.positions | currency: summary.buySales.currency }}</td>
                    <td>
                        {{ summary.buy.positions | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.positions | currency: summary.buy.currency }})
                        </span>
                    </td>
                </tr>
                <ng-container *ngIf="summary.groups.length > 1">
                    <tr *ngFor="let group of summary.groups">
                        <td class="intent">{{ 'SALES_DOCUMENT|w tym {groupName} netto' | translate: {groupName: (group.name | translate)} }}</td>
                        <td>{{ group.buySales?.value | currency: summary.buySales.currency }}</td>
                        <td>
                            {{ group.buy?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                            <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                                ({{ group.buy?.value | currency: summary.buy.currency }})
                            </span>
                        </td>
                    </tr>
                </ng-container>
                <ng-container *ngFor="let group of summary.groupsPositions">
                    <tr>
                        <td>{{ 'SALES_DOCUMENT|{groupName} netto' | translate: {groupName: (group.name | translate)} }}</td>
                        <td>{{ group.buySales?.total | currency: summary.buySales.currency }}</td>
                        <td>
                            {{ group.buy?.total  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                            <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                                ({{ group.buy?.total  | currency: summary.buy.currency }})
                            </span>
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td>{{ 'SALES_DOCUMENT|RAZEM:' | translate }}</td>
                    <td>{{ summary.buySales.totalBeforeDiscountsAndPromotions | currency: summary.buySales.currency }}</td>
                    <td>
                        {{ summary.buy.totalBeforeDiscountsAndPromotions | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalBeforeDiscountsAndPromotions | currency: summary.buy.currency }})
                        </span>
                    </td>
                </tr>
                <tr *ngIf="summary.buySales.promotion?.value || summary.buy.promotion?.value">
                    <td>{{ 'SALES_DOCUMENT|Wartość promocji:' | translate }}</td>
                    <td>({{ summary.buySales.promotion?.promotion / 100 | percent : '1.0-2' }}) {{ summary.buySales.promotion?.value | currency: summary.buySales.currency }}</td>
                    <td>
                        ({{ summary.buy.promotion?.promotion / 100 | percent : '1.0-2' }}) {{ summary.buy.promotion?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.promotion?.value | currency: summary.buy.currency }})
                        </span>
                    </td>
                </tr>
                <tr *ngIf="summary.buySales.promotion?.value || summary.buy.promotion?.value">
                    <td>{{ 'SALES_DOCUMENT|RAZEM PO PROMOCJI:' | translate }}</td>
                    <td>{{ summary.buySales.totalAfterPromotions | currency: summary.buySales.currency }}</td>
                    <td>
                        {{ summary.buy.totalAfterPromotions | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalAfterPromotions | currency: summary.buy.currency }})
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>{{ 'SALES_DOCUMENT|Rabat:' | translate }}</td>
                    <td>{{ summary.buySales.totalDiscount | currency: summary.buySales.currency }}</td>
                    <td>
                        {{ summary.buy.totalDiscount | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalDiscount | currency: summary.buy.currency }})
                        </span>
                    </td>
                </tr>
                <tr>
                    <td class="intent">{{ 'SALES_DOCUMENT|w tym rabat do pozycji:' | translate }}</td>
                    <td>({{ summary.buySales.discount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buySales.discount?.value | currency: summary.buySales.currency }}</td>
                    <td>
                        ({{ summary.buy.discount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buy.discount?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.discount?.value | currency: summary.buy.currency }})
                        </span>
                    </td>
                </tr>
                <tr>
                    <td class="intent">{{ 'SALES_DOCUMENT|w tym rabat dodatkowy:' | translate }}</td>
                    <td>({{ summary.buySales.additionalDiscount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buySales.additionalDiscount?.value | currency: summary.buySales.currency }}</td>
                    <td>
                        ({{ summary.buy.additionalDiscount?.discount / 100 | percent : '1.0-2' }}) {{ summary.buy.additionalDiscount?.value  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency }}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.additionalDiscount?.value | currency: summary.buy.currency }})
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>{{ 'SALES_DOCUMENT|RAZEM NETTO:' | translate }}</td>
                    <td>{{ summary.buySales.totalAfterDiscounts | currency: summary.buySales.currency }}</td>
                    <td>
                        {{ summary.buy.totalAfterDiscounts | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalAfterDiscounts | currency: summary.buy.currency}})
                        </span>
                    </td>
                </tr>
                <ng-container *ngFor="let tax of summary.taxes">
                    <tr >
                        <td>{{ 'SALES_DOCUMENT|VAT {rate}' | translate: {rate: (tax.taxRate / 100 | percent)} }}</td>
                        <td>{{ tax.buySales?.tax | currency: summary.buySales.currency : '—' }}</td>
                        <td>
                            {{ tax.buy?.tax  | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency : '—' }}
                            <span class="buy-currency-price" *ngIf="tax.buy?.tax != null && summary.buy?.currency != summary.buySales?.currency">
                                ({{ tax.buy?.tax | currency: summary.buy.currency }})
                            </span>
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td>{{ 'SALES_DOCUMENT|RAZEM BRUTTO:' | translate }}</td>
                    <td>{{ summary.buySales.totalGrossAfterDiscounts | currency: summary.buySales.currency }}<span *ngIf="summary.buySales.hasNonValuatedPositions" class="non-valuated">* {{ 'SALES_DOCUMENT|Do wyceny' | translate }}</span></td>
                    <td>
                        {{ summary.buy.totalGrossAfterDiscounts | exchange: summary.buy.currency : summary.buySales.currency : buyExchangeRates | currency: summary.buySales.currency}}<span *ngIf="summary.buy.hasNonValuatedPositions" class="non-valuated">*</span>
                        <span class="buy-currency-price" *ngIf="summary.buy?.currency != summary.buySales?.currency">
                            ({{ summary.buy.totalGrossAfterDiscounts | currency: summary.buy.currency }})</span><span *ngIf="summary.buy.hasNonValuatedPositions" class="non-valuated">* {{ 'SALES_DOCUMENT|Do wyceny' | translate }}</span>
                    </td>
                </tr>

                <tr>
                    <td></td>
                    <td>{{ 'SALES_DOCUMENT|Wynik netto:' | translate }}</td>
                    <td>{{ summary.result.value | currency: currency }}</td>
                </tr>
                <tr>
                    <td></td>
                    <td>{{ 'SALES_DOCUMENT|Marża:' | translate }}</td>
                    <td>{{ summary.result.margin | percent }}</td>
                </tr>
                <tr>
                    <td></td>
                    <td>{{ 'SALES_DOCUMENT|Narzut:' | translate }}</td>
                    <td>{{ summary.result.overhead | percent }}</td>
                </tr>
            </tbody>
        </table>

        <p class="icc-card__content__error" *ngIf="mode === 'purchase' && summary.buy?.hasNonValuatedPositions">{{ 'SALES_DOCUMENT|*Nie wszystkie pozycje zostały wycenione. Liczba niewycenionych pozycji: {count}.' | translate: {count: summary.buy?.nonValuatedPositionsCount} }}</p>
        <p class="icc-card__content__error" *ngIf="mode !== 'purchase' && summary.sales?.hasNonValuatedPositions">{{ 'SALES_DOCUMENT|*Nie wszystkie pozycje zostały wycenione. Liczba niewycenionych pozycji: {count}.' | translate: {count: summary.sales?.nonValuatedPositionsCount} }}</p>
    </div>
    <div id="new-positions" *ngIf="openedDocument && (mode === 'comparison' || mode === 'sale' || openedDocument?.salesDocumentTypeId === 5) && (hasAccessTo.addPosition || hasAccessTo.addOwnPosition)">
        <div class="icc-card" >
            <span class="icc-card__label">
                {{ 'SALES_DOCUMENT|Dodaj nową pozycję:' | translate }}
            </span>
            <span class="icc-card__content">

                <button
                    iccButton
                    appearance="outline"
                    [routerLink]="'/trade/products' + (openedDocument?.salesDocumentTypeId === 5 ? '/spare-parts' : '')"
                    *ngIf="hasAccessTo.addPosition"
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'PRODUCT|Z katalogu' | translate }}
                </button>


                <ng-container *ngIf="hasClassicConfigurator && hasAccessTo.addPosition" >
                    <button iccButton appearance="primary" routerLink="/configurator/configure/external_venetian">
                        <icc-icon name="configure"></icc-icon>
                        {{ 'EXTERNAL_VENETIAN|Żaluzja i osłony' | translate }}
                    </button>
                </ng-container>

                <button iccButton appearance="outline" (click)="openOwnProductsDialog()" *ngIf="hasAccessTo.addOwnPosition">
                    {{ 'SALES_DOCUMENT|Pozycja dodatkowa' | translate }}
                </button>


            </span>
        </div>
    </div>
</div>

<div id="document-alert" *ngIf="!integral" #alert>
    <p>{{ 'SALES_DOCUMENT|Dokumenty sprzedaży i zakupu nie są ze sobą spójne. Dokument zakupu został aneksowany. Zmiany nie zostały jeszcze przeniesione na dokument sprzedaży.' | translate}}</p>
    <button
        iccButton
        *ngIf="hasAccessTo.transferChanges"
        (click)="transferChanges(salesDocument)"
        [disabled]="synced !== 'synced' && synced !== 'offline'"
    >{{ 'SALES_DOCUMENT|Przenieś zmiany' | translate }}</button>
</div>
<div id="document-alert" *ngIf="mode === 'purchase' && buyDocuments[0]?.toSendToExternalSystem && !buyDocuments[0]?.isOrderPlaced" #alert>
    <p>{{ 'SALES_DOCUMENT|Brak potwierdzenia zapisu zamówienia, oczekuj na powiadomienie email o stanie transakcji. W przypadku braku powiadomienia w ciągu 24h skontaktuj się ze swoim opiekunem klienta w celu wyjaśnienia sprawy.' | translate}}</p>
    <button
        iccButton
        *ngIf="hasAccessTo.placeOrder"
        (click)="placeOrder()"
        [disabled]="synced !== 'synced' && synced !== 'offline'"
    >{{ 'SALES_DOCUMENT|Spróbuj ponownie' | translate }}</button>
    <button
        iccButton
        *ngIf="hasAccessTo.placeOrder"
        (click)="withdrawPlaceOrders(salesDocument)"
        [disabled]="synced !== 'synced' && synced !== 'offline'"
    >{{ 'SALES_DOCUMENT|Zrezygnuj' | translate }}</button>
</div>
<div id="document-actions" [class.document-actions--blocked]="invalidVersion && loaded">
    <div class="document-actions-row" *ngIf="mobileView">
        <p *ngIf="hasAccessTo.cantModifyInfo && cantManageOrderInfo" [innerHTML]="cantManageOrderInfo"></p>
    </div>
    <div class="document-actions-row" *ngIf="loaded && invalidVersion && salesDocument && !salesDocument.isCanceled && !(priceUpdatePending$ | async) && !salesDocument.isConfirmed && salesDocument.salesDocumentTypeId !== 2 && mobileView">
        <div class="document-actions--blocked-message">
            <p *ngIf="salesDocument.salesDocumentTypeId !== 3">{{ 'SALES_DOCUMENT|Oferta została stworzona przy użyciu innej wersji cenowej niż aktualnie aktywowana. Możesz przeliczyć ofertę na aktualnie dostępną wersje cen' | translate }}</p>
            <p *ngIf="salesDocument.salesDocumentTypeId === 3">{{ 'SALES_DOCUMENT|Zamówienie zostało stworzone przy użyciu innej wersji cenowej niż aktualnie aktywowana. Możesz przeliczyć zamówienie na aktualnie dostępną wersje cen' | translate }}</p>
            <p *ngIf="buyIsInModification">{{ 'SALES_DOCUMENT|Uwaga! Dokument zakupu jest nadal w trybie edycji. Sprzedający nie zakończył jeszcze modyfikacji.' | translate }}</p>
        </div>
    </div>
    <div class="document-actions-row">
        <div class="document-actions-bar document-actions-bar__left">
            <button
                iccButton
                appearance="secondary"
                (click)="backToList()"
            >
                <icc-icon name="list"></icc-icon>
                {{ getBtnBackText() }}
            </button>
            <div *ngIf="!invalidVersion && !mobileView" class="document-actions-bar">
                <ng-container *ngFor="let action of documentActions">
                    <ng-container *ngIf="action.side ==='left'">
                        <button
                            iccButton
                            [appearance]="action.appearance"
                            *ngIf="action.show()"
                            (click)="action.action()"
                            [disabled]="action.disabled()"
                            [attr.data-test]="action.testId"
                        >
                            <icc-icon [name]="action.icon"></icc-icon>
                            {{ action.label | translate }}
                        </button>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="document-actions-bar">
            <icc-synced-indicator [documents]="openedDocumentsIds" [syncedDocuments]="syncedDocumentsState"></icc-synced-indicator>
        </div>
        <div class="document-actions-bar" *ngIf="!loaded"></div>
        <div class="document-actions-bar document-actions-bar__right" *ngIf="!invalidVersion">

            <p *ngIf="hasAccessTo.cantModifyInfo && cantManageOrderInfo && !mobileView" [innerHTML]="cantManageOrderInfo"></p>
            <ng-container *ngIf="!mobileView">
                <ng-container *ngFor="let action of documentActions">
                    <ng-container *ngIf="action.side ==='right'">
                        <button
                            iccButton
                            [appearance]="action.appearance"
                            *ngIf="action.show() && !action.children?.length"
                            (click)="action.action()"
                            [disabled]="action.disabled()"
                            [attr.data-test]="action.testId"
                        >
                            <icc-icon [name]="action.icon"></icc-icon>
                            {{ action.label | translate }}
                        </button>
                    </ng-container>

                    <div class="button-group" *ngIf="action.show() && action.children?.length">
                        <button
                            iccButton
                            [appearance]="action.appearance"
                            (click)="action.action()"
                            [disabled]="action.disabled()"
                            [attr.data-test]="action.testId"
                        >
                            <icc-icon [name]="action.icon"></icc-icon>
                            {{ action.label | translate }}
                        </button>
                        <button iccButton appearance="secondary" [iccMenuTriggerFor]="appMenu" [disabled]="synced !== 'synced'">
                            <icc-icon name="expand_more"></icc-icon>
                        </button>
                        <icc-menu #appMenu="iccMenu" xPosition="before" yPosition="below" [class]="'no-border'">
                            <ng-container *ngFor="let child of action.children">
                                <button
                                    iccButton
                                    [appearance]="child.appearance"
                                    *ngIf="child.show()"
                                    (click)="child.action()"
                                    [disabled]="child.disabled()"
                                    [attr.data-test]="child.testId"
                                >
                                    <icc-icon [name]="child.icon"></icc-icon>
                                    {{ child.label | translate }}
                                </button>
                            </ng-container>
                        </icc-menu>
                    </div>
                </ng-container>
            </ng-container>
            <button
                iccButton
                appearance="primary"
                [iccMenuTriggerFor]="documentActionsMenu"
                data-test="actions-menu-mobile"
                *ngIf="mobileView && hasAccessToAny(documentActions)"
            >
                <icc-icon name="menu"></icc-icon>
                {{ 'SALES_DOCUMENT|Akcje' | translate }}
            </button>
            <icc-menu #documentActionsMenu="iccMenu" xPosition="before" yPosition="above">
                <ng-container *ngFor="let action of documentActions">
                    <ng-container *ngIf="action.side === 'right'">
                        <button
                            icc-menu-item
                            [appearance]="action.appearance"
                            *ngIf="action.show()"
                            (click)="action.action()"
                            [disabled]="action.disabled()"
                            [attr.data-test]="action.testId"
                        >
                            <icc-icon [name]="action.icon"></icc-icon>
                            {{ action.label | translate }}
                        </button>
                        <ng-container *ngFor="let child of (action.children || [])">
                            <button
                                icc-menu-item
                                [appearance]="child.appearance"
                                *ngIf="child.show()"
                                (click)="child.action()"
                                [disabled]="child.disabled()"
                                [attr.data-test]="child.testId"
                            >
                                <icc-icon [name]="child.icon"></icc-icon>
                                {{ child.label | translate }}
                            </button>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngFor="let action of documentActions">
                    <ng-container *ngIf="action.side === 'left'">
                        <button
                            icc-menu-item
                            [appearance]="action.appearance"
                            *ngIf="action.show()"
                            (click)="action.action()"
                            [disabled]="action.disabled()"
                            [attr.data-test]="action.testId"
                        >
                            <icc-icon [name]="action.icon"></icc-icon>
                            {{ action.label | translate }}
                        </button>
                        <ng-container *ngFor="let child of (action.children || [])">
                            <button
                                icc-menu-item
                                [appearance]="child.appearance"
                                *ngIf="child.show()"
                                (click)="child.action()"
                                [disabled]="child.disabled()"
                                [attr.data-test]="child.testId"
                            >
                                <icc-icon [name]="child.icon"></icc-icon>
                                {{ child.label | translate }}
                            </button>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </icc-menu>
        </div>
        <div *ngIf="loaded && invalidVersion && salesDocument && !salesDocument.isCanceled && !(priceUpdatePending$ | async) && !salesDocument.isConfirmed && salesDocument.salesDocumentTypeId !== 2" class="document-actions--blocked-actions" [class.document-actions-bar__right]="mobileView">
            <div class="document-actions--blocked-message" *ngIf="!mobileView">
                <p *ngIf="salesDocument.salesDocumentTypeId !== 3">{{ 'SALES_DOCUMENT|Oferta została stworzona przy użyciu innej wersji cenowej niż aktualnie aktywowana. Możesz przeliczyć ofertę na aktualnie dostępną wersje cen' | translate }}</p>
                <p *ngIf="salesDocument.salesDocumentTypeId === 3">{{ 'SALES_DOCUMENT|Zamówienie zostało stworzone przy użyciu innej wersji cenowej niż aktualnie aktywowana. Możesz przeliczyć zamówienie na aktualnie dostępną wersje cen' | translate }}</p>
                <p *ngIf="buyIsInModification">{{ 'SALES_DOCUMENT|Uwaga! Dokument zakupu jest nadal w trybie edycji. Sprzedający nie zakończył jeszcze modyfikacji.' | translate }}</p>
            </div>
            <button iccButton (click)="confirmRecalculate(salesDocument)" data-test="recalculate-button">
                <icc-icon name="calculate"></icc-icon>
                {{ 'PRICE_VERSION|Przelicz wersję cenową' | translate }}
            </button>
        </div>
    </div>
</div>
<div *ngIf="salesDocument && !salesDocument.isCanceled && invalidUnitsInDocument">
    <p>{{ 'PRICE_VERSION|Nie można przeliczyć wersji cenowej, ponieważ jednostki cenowe użyte przy wyliczaniu cen nie są dostępne w aktywnej wersji cenowej' | translate }}</p>
</div>
